/**
 * TODO
 *  -   Specify errors thrown by dashjs?
 *  -   Specify errors thrown by hls.js
 *  -   The error thrown by HTML5 media elements is mapped to internal error names in the ErrorHandler plugin, should be a core functionality?
 */

export default {
    DEFAULT_ERROR: 'defaultError',
    DRM_PROTECTION_ERROR: 'drmProtectionError',
    FLASH_NOT_SUPPORTED: 'flashNotSupported',
    GEO_BLOCK_ERROR: 'geoblockError',
    IMMERSIVE_NOT_SUPPORTED_ERROR: 'immersiveNotSupported',
    IMMERSIVE_FAILED_TO_LOAD: 'immersiveFailedToLoad',
    LIVE_NOT_STARTED_ERROR: 'liveNotStartedError',
    LOAD_ERROR: 'loadError',
    LOAD_PLAYER_ERROR: 'loadPlayerError',
    RIGHTS_EXPIRED_ERROR: 'rightsExpiredError',
    PROGRAM_NOT_STARTED_ERROR: 'programNotStartedError',
    UNKNOW_VIDEO_TYPE_ERROR: 'unknownVideoTypeError',

    // Originates from HTML5 MediaError
    MEDIA_ERROR_ABORTED: 'mediaErrorAborted',
    MEDIA_ERROR_NETWORK: 'mediaErrorNetwork',
    MEDIA_ERROR_DECODE: 'mediaErrorDecode',
    MEDIA_ERROR_SRC_NOT_SUPPORTED: 'mediaErrorSrcNotSupported'
};



// WEBPACK FOOTER //
// ./src/js/constants/error-type.js